import { w } from 'windstitch';

export const Wrapper = w.div(
  'w-full p-4 xl:p-0 my-[36px] lg:my-[128px] bg-cover bg-center flex items-center justify-center relative h-[633px]',
);

export const CardBlur = w.div(
  'w-full xl:w-[1261px] h-[438px] rounded-[219px] bg-[var(--marine-400)] absolute overflow-hidden blur-[50px]',
);

export const Card = w.div(
  'w-[1261px] h-[438px] lg:rounded-[219px] flex items-center justify-center flex-col absolute overflow-hidden relative',
);

export const CardH2 = w.h2(
  'font-roboto font-bold text-[32px] lg:text-[56px] leading-[64px] tracking-[0.125rem] text-center',
);

export const CardP = w.p(
  'font-opensans font-normal text-base leading-6 tracking-normal text-center my-[48px] text-[14px] lg:text-[16px]',
);

export const Btn = w.button(
  'h-10 px-4 py-2 gap-2 rounded-[24px] flex items-center  bg-[var(--lime-500)] text-[var(--lime-800)] hover:bg-[var(--marine-300)] over:text-[var(--lime-500)]'
);